import SvgArrow from "./svg-arrow";

export default SvgArrow;
